import React from 'react';
import PropTypes from 'prop-types';
import { Menu, Dropdown, Button, Spin, Tooltip } from 'antd';
import { DownOutlined, LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const DropdownMenuButton = ({
  onMenuItemClick,
  options,
  label,
  className,
  isDisabled,
  isLoading,
  disabledTooltip,
  placement = 'bottomRight'
}) => {
  // FIN-10524, FIN-10451: Support per-item tooltips for disabled menu items (PRD Rule #6)
  const menu = (
    <Menu onClick={onMenuItemClick}>
      {options.map(
        ({ value, label, onClick, disabled, disabledTooltip: itemTooltip }) => {
          const menuItem = (
            <Menu.Item
              key={value ?? label}
              onClick={onClick}
              disabled={disabled}>
              {label}
            </Menu.Item>
          );
          if (disabled && itemTooltip) {
            return (
              <Tooltip
                key={value ?? label}
                title={itemTooltip}
                placement="left">
                <span>{menuItem}</span>
              </Tooltip>
            );
          }
          return menuItem;
        }
      )}
    </Menu>
  );

  const button = (
    <Dropdown
      placement={placement}
      overlay={menu}
      trigger="click"
      className={className}>
      <StyledSpin
        spinning={Boolean(isLoading)}
        indicator={
          <LoadingOutlined style={{ fontSize: 20, color: '#21b4bd' }} spin />
        }>
        <StyledButton type="primary" disabled={isDisabled}>
          {label} <StyledDownOutlined fill="white" />
        </StyledButton>
      </StyledSpin>
    </Dropdown>
  );

  if (disabledTooltip && isDisabled) {
    return (
      <Tooltip title={disabledTooltip}>
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
};

const StyledSpin = styled(Spin)`
  display: flex;
`;

const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
`;

const StyledDownOutlined = styled(DownOutlined)``;

DropdownMenuButton.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      onClick: PropTypes.func,
      disabled: PropTypes.bool,
      disabledTooltip: PropTypes.string
    })
  ).isRequired,
  label: PropTypes.string.isRequired,
  onMenuItemClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  disabledTooltip: PropTypes.string,
  placement: PropTypes.string,
  className: PropTypes.string
};

export default DropdownMenuButton;
